import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import Loader from './components/blacktel/loader/Loader'
import globalComponent from './plugins/global'
// import Stripe from 'stripe';
import VueTelInput from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'

const mixin = {
  data() {
    return {}
  },
  mounted() {},
  methods: {
    checkValidate(err) {
      if(err.length > 0) {
        return true
      }
      return false
    },
    getCredit() {
      this.$store
        .dispatch('btPostApi', {
          url: 'https://private.blacktel.io/user-detail',
          data: {
            mid: localStorage.getItem('mid'),
            secureid: localStorage.getItem('secureid')
          }
        })
        .then((response) => {
          if (response.data[0].status === 'success') {
            this.$store.dispatch('accountCredit', response.data[1].messages.credit)
          }
        })
    }
  }
}
const app = createApp(App)
app.mixin(mixin)
app.use(router)
app.use(store)
app.use(globalComponent)
app.use(VueTelInput, {
  showDialCodeInSelection: true,
  mode: "international",
  autoFormat: true,
});
app.use(Loader)
app.config.debug = false;
app.config.silent = true;
app.config.productionTip = false;

// import client sdk for c  lling and payment
window.Twilio = {
  Devices : null,
  Device: null,
  Call: null
}

window.Plivo = require('plivo-browser-sdk')
window.Twilio = require('./external_node/twilio')

app.mount('#app')

window.vm = app
